module.exports = __webpack_public_path__ + "img/banner.c31d4a74.jpg";